import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Per-product quality scorecard route
 * (`/explorer/data-quality/product/$connectionId/$externalId`). Super-admin
 * only; lazy-loaded. Reached from the dashboard Products tab.
 */
const ProductQualityDetailPage = lazy(
  () => import('~/features/explorer/pages/product-quality-detail-page'),
);

// `sc` carries the subsidiary scope from the dashboard so the scorecard queries
// hit the same subsidiary and the back link returns to it.
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute(
  '/_authenticated/_tenant/explorer/data-quality/product/$connectionId/$externalId',
)({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

function RouteComponent() {
  const { connectionId, externalId } = Route.useParams();
  const { sc } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ProductQualityDetailPage
        connectionId={connectionId}
        externalId={externalId}
        subsidiaryId={sc}
      />
    </Suspense>
  );
}
